import { type FC } from 'react';
import { Skeleton } from 'antd';
import { Text, Space, InputText, Button } from '@g2u/ui-kit';
import cx from 'classnames';

import { JsonData, JsonDataItem, ServiceReceipt, type WithOptionalDataTest } from 'types';
import styles from './receipt.module.scss';

type Props = {
  receipts?: ServiceReceipt[];
  receiptsTotal: string;
  outstandingAmount: string;
  hasDebt: boolean;
  paymentMethods?: JsonData;
  isLoading?: boolean;
} & WithOptionalDataTest;

export const Receipt: FC<Props> = (props) => {
  const { receipts, receiptsTotal, outstandingAmount, isLoading, paymentMethods, hasDebt } = props;

  if (!receipts?.length) return null;

  return (
    <>
      <Text.$ strong size={Text.Size.LG} className={cx(styles.receipt__title)}>
        Receipt
      </Text.$>
      {isLoading ? (
        <Skeleton />
      ) : (
        <>
          <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle} align={Space.Align.Start}>
            {receipts?.length &&
              receipts.map((receipt) => (
                <div key={receipt.ID}>
                  <Space.$ size={Space.Size.Small} align={Space.Align.End}>
                    <InputText.$
                      name={`receipt-id-${receipt.ID}`}
                      label="Receipt ID:"
                      initialValue={receipt.ID.toString()}
                      disabled
                      width={115}
                    />
                    <InputText.$
                      name={`receipt-date-${receipt.ID}`}
                      label="Receipt Date:"
                      initialValue={receipt.date}
                      disabled
                      width={115}
                    />
                    <InputText.$
                      name={`receipt-method-${receipt.ID}`}
                      label="Payment Method:"
                      initialValue={paymentMethods?.find((method: JsonDataItem) => method.ID === receipt.type)?.name}
                      disabled
                      width={200}
                    />
                    <InputText.$
                      name={`receipt-amount-${receipt.ID}`}
                      label="Receipt Amount:"
                      initialValue={receipt.amount}
                      disabled
                      width={115}
                      className={styles.receipt__amount}
                    />
                    {/* TODO: Implement when API is ready */}
                    <Button.$ dataTestId={`receipt-print-btn-${receipt.ID}`} onClick={() => null} disabled>
                      Print
                    </Button.$>
                  </Space.$>
                </div>
              ))}
          </Space.$>
          <div className={styles.receipt__total}>
            <div className={styles.receipt__totalContent}>
              <Text.$>Receipt Total:</Text.$>
              <Text.$>${receiptsTotal}</Text.$>
              <Text.$>Outstanding Amount:</Text.$>
              <Text.$ type={hasDebt ? 'danger' : 'success'}>${outstandingAmount}</Text.$>
            </div>
          </div>
        </>
      )}
    </>
  );
};
